module.exports = __webpack_public_path__ + "static/media/gastro-image1@2x.13367fe5.png";